import { Routes, Route, Navigate } from 'react-router-dom';
import PasswordInit from './legacy/routes/PasswordInit';
import { ProtectedRoute } from './ProtectedRoute';
import type React from 'react';
import StreetView from './legacy/components/StreetView';
import ManualCalibration from './legacy/components/ManualCalibration';
import { LoginPage } from './authentication/LoginPage';
import MapView from './network-map';
import { SessionsListPage } from './session/list-sessions/SessionsListPage';
import { ReferencesListPage } from './reference/list-references/ReferencesListPage';
import { NetworkListPage } from './network/list-network/NetworkListPage';
import { ProjectListPage } from './project/list-project/ProjectListPage';
import { Layout } from './Layout';
import Dashboard from './legacy/routes/Dashboard';

export const AppRoutes: React.FC<{}> = () => {
    return (
        <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route
                path="/map"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<MapView />} />
            </Route>
            <Route
                path="/acquisition"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="*" element={<Dashboard />}>
                    <Route index element={<SessionsListPage />} />
                </Route>
            </Route>
            <Route
                path="/reference"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="*" element={<Dashboard />}>
                    <Route index element={<ReferencesListPage />} />
                </Route>
            </Route>
            <Route
                path="/network-state"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="*" element={<Dashboard />}>
                    <Route index element={<NetworkListPage />} />
                </Route>
            </Route>
            <Route
                path="/project"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="*" element={<Dashboard />}>
                    <Route index element={<ProjectListPage />} />
                </Route>
            </Route>
            <Route path="/acquisition/street-view/:sessionId" element={<Dashboard />}>
                <Route
                    index
                    element={
                        <ProtectedRoute>
                            <StreetView />
                        </ProtectedRoute>
                    }
                />
            </Route>
            <Route path="/acquisition/calibration/*" element={<Dashboard />}>
                <Route
                    index
                    element={
                        <ProtectedRoute>
                            <ManualCalibration />
                        </ProtectedRoute>
                    }
                />
            </Route>
            <Route
                path="/init-password"
                element={
                    <ProtectedRoute>
                        <PasswordInit />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};
